import VueRouter from 'vue-router'
import Vue from 'vue'

const lineList = resolve => require(['../../pages/platform/pages/line-list'], resolve);
const workList = resolve => require(['../../pages/platform/pages/work-list'], resolve);
const workListNew = resolve => require(['../../pages/platform/pages/work-list-new'], resolve);
const workListDetail = resolve => require(['../../pages/platform/pages/work-list-detail'], resolve);
const workListSearch = resolve => require(['../../pages/platform/pages/work-list-search'], resolve);

const evaluation = resolve => require(['../../pages/platform/pages/evaluation'], resolve);
const evaluationList = resolve => require(['../../pages/platform/pages/evaluation-list'], resolve);
const evaluationDetail = resolve => require(['../../pages/platform/pages/evaluation-detail'], resolve);

const platformSet = resolve => require(['../../pages/platform/pages/platformSet'], resolve);


const Home = resolve => require(['../../pages/home/home'], resolve);
const Index = resolve => require(['../../pages/home/index'], resolve);
const ProductPhone = resolve => require(['../../pages/home/phone'], resolve);
const BusAgent = resolve => require(['../../pages/home/agent'], resolve);
const BusContact = resolve => require(['../../pages/home/agent'], resolve);
const KefuGuide = resolve => require(['../../pages/home/guide'], resolve);
const PhoneGuide = resolve => require(['../../pages/home/phoneGuide'], resolve);
const DownApp = resolve => require(['../../pages/home/downApp'], resolve);
const ICS = resolve => require(['../../pages/home/ics'], resolve);


const Robot = resolve => require(['../../pages/robot'], resolve);
const Platform = resolve => require(['../../pages/platform/pages/platform'], resolve);
const UserManager = resolve => require(['../../pages/allSet/userManager'], resolve);
const SystemButt = resolve => require(['../../pages/allSet/systemButt'], resolve);
const UserGroup = resolve => require(['../../pages/allSet/userGroup'], resolve)
// const WorkList = resolve => require(['../../pages/allSet/WorkListSet'],resolve)

const AllSet = resolve => require(['../../pages/allSet/allSet'], resolve);
const Login = resolve => require(['../../pages/login'], resolve);
const Protocol = resolve => require(['../../pages/protocol'], resolve);
const SDK = resolve => require(['../../pages/robot/sdk/sdk'], resolve);
const WechatPublic = resolve => require(['../../pages/robot/sdk/Wechatpublic'], resolve);
const WechatPerson = resolve => require(['../../pages/robot/sdk/WechatPersonal'], resolve);
const AppAccess = resolve => require(['../../pages/robot/sdk/AppAccess'], resolve);
const ApiAccess = resolve => require(['../../pages/robot/sdk/apiAccess'], resolve);
const WebAccess = resolve => require(['../../pages/robot/sdk/WebAccess'], resolve);
const WechatProgram = resolve => require(['../../pages/robot/sdk/WechatProgram'], resolve);
const newWechat = resolve => require(['../../pages/robot/sdk/newWechat'], resolve);
const WechatPersonalSet = resolve => require(['../../pages/robot/sdk/wechatPersonalSet'], resolve);
// const WechatQQ = resolve => require(['../../pages/robot/sdk/qq'], resolve);


const Weibo = resolve => require(['../../pages/robot/sdk/Weibo'], resolve);
const WechatCompany = resolve => require(['../../pages/robot/sdk/WechatCompany'], resolve);
const WeiboHelp = resolve => require(['../../pages/robot/weiboHelp'], resolve);
const systemComponent = resolve => require(['../../pages/systemComponent'], resolve);
const List = resolve => require(['../../pages/list'], resolve);
const Rules = resolve => require(['../../pages/robot/rules'], resolve);
const AddRulesWrap = resolve => require(['../../pages/robot/AddRulesWrap'], resolve);
const Word = resolve => require(['../../pages/robot/word'], resolve);
const EditWord = resolve => require(['../../pages/robot/EditWord'], resolve);
const robotInfo = resolve => require(['../../pages/robot/robotInfo'], resolve);
const clientSet = resolve => require(['../../pages/robot/clientSet'], resolve);
const response = resolve => require(['../../pages/robot/response'], resolve);
const responseAdd = resolve => require(['../../pages/robot/response/add'], resolve);
const unknownQ = resolve => require(['../../pages/robot/unknownQ'], resolve);
const Material = resolve => require(['../../pages/robot/material'], resolve);
const AddMaterial = resolve => require(['../../pages/robot/addMaterial'], resolve);
const history = resolve => require(['../../pages/robot/history'], resolve);
const DataStatistics = resolve => require(['../../pages/robot/DataStatistics'], resolve);
const KbStatistics = resolve => require(['../../pages/robot/KbStatistics'], resolve);
const customerService = resolve => require(['../../pages/robot/customerService'], resolve);
const resetPassword = resolve => require(['../../pages/resetPassword'], resolve);
const register = resolve => require(['../../pages/register'], resolve);
const perviewRobot = resolve => require(['../../pages/previewRobot'], resolve);
const ruleErrData = resolve => require(['../../pages/robot/rulesErrData'], resolve);
const UserInfo = resolve => require(['../../pages/userinfo'], resolve);
const CompanyInfo = resolve => require(['../../pages/companyInfo'], resolve);
const Visitor = resolve => require(['../../pages/visitor/visitor'], resolve);
const WorkReply = resolve => require(['../../pages/visitor/pages/visitor-work-reply'], resolve);


const union = resolve => require(['../../pages/union/index'], resolve)
const tenantDetail = resolve => require(['../../pages/union/pages/tenantDetail'], resolve)
const tenantDetailById = resolve => require(['../../pages/union/pages/tenantDetailById'], resolve)
const tenantManager = resolve => require(['../../pages/union/pages/tenantManager'], resolve)
const visitorStatistics = resolve => require(['../../pages/union/pages/visitorStatistics'], resolve)


// 页面跳转
const changeHref = resolve => require(['../../pages/changeHref'], resolve);


Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/changeHref',
    component: changeHref
  },
  {
    path: '/visitor',
    component: Visitor,
    children: [{
      path: 'work-reply/:tenantId',
      component: WorkReply
    }]
  },
  {
    path: '/home',
    component: Home,
    children: [{
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        component: Index
      },
      {
        path: 'product/ics',
        component: ICS
      },
      {
        path: 'product/phone',
        component: ProductPhone
      },
      {
        path: 'business/agent',
        component: BusAgent
      },
      {
        path: 'business/contact',
        component: BusContact
      },
      {
        path: 'guide/kefu',
        component: KefuGuide
      },
      {
        path: 'guide/phone',
        component: PhoneGuide
      },
      {
        path: 'downApp',
        component: DownApp
      }
    ]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/resetPassword',
    component: resetPassword
  },
  {
    path: '/register',
    component: register
  },
  {
    path: '/weibohelp',
    component: WeiboHelp
  },
  {
    path: '/protocol',
    component: Protocol
  },
  {
    path: '/perview-robot',
    component: perviewRobot
  },
  {
    path: '/system',
    component: systemComponent,
    children: [
      // { path: '', redirect: 'robot/list' },
      {
        path: 'robot/list',
        component: List
      },
      {
        path: 'robot',
        component: Robot,
        children: [{
            path: '',
            redirect: 'rules'
          },
          {
            path: 'rules',
            component: Rules
          },
          {
            path: 'rules/addrules',
            component: AddRulesWrap,
            name: '编辑问答'
          },
          {
            path: 'word',
            component: Word
          },
          {
            path: 'word/editWord',
            component: EditWord
          },
          // {path:'addword',component:AddWord},
          {
            path: 'robot-info',
            component: robotInfo
          },
          {
            path: 'clientSet',
            component: clientSet
          },
          {
            path: 'response',
            component: response
          },
          {
            path: 'response/add',
            component: responseAdd
          },
          {
            path: 'unknownq',
            component: unknownQ
          },
          {
            path: 'material',
            component: Material,
            name: 'material'
          },
          {
            path: 'material/addmaterial',
            component: AddMaterial,
            name: '编辑素材'
          },
          {
            path: 'history',
            component: history
          },
          {
            path: 'evaluation',
            component: evaluation,
            children: [{
                path: '',
                redirect: 'list'
              },
              {
                path: 'list',
                component: evaluationList
              },
              {
                path: 'detail',
                component: evaluationDetail
              },
            ]
          },
          {
            path: 'visitor-statistics',
            component: DataStatistics
          },
          {
            path: 'kb-statistics',
            component: KbStatistics
          },
          {
            path: 'customerService',
            component: customerService
          },
          {
            path: 'sdk',
            name: 'sdk',
            component: SDK
          },
          {
            path: 'sdk/wechat-public',
            component: WechatPublic
          },
          {
            path: 'sdk/newWechat',
            component: newWechat
          },
          {
            path: 'sdk/wechatPersonalSet/:serverId/:wechatId',
            component: WechatPersonalSet
          },
          {
            path: 'sdk/wechat-person',
            component: WechatPerson
          },
          {
            path: 'sdk/app',
            component: AppAccess
          },
          {
            path: 'sdk/api',
            component: ApiAccess
          },
          {
            path: 'sdk/web',
            component: WebAccess
          },
          {
            path: 'sdk/wechat-program',
            component: WechatProgram
          },
          {
            path: 'sdk/weibo',
            component: Weibo
          },
          {
            path: 'sdk/wechat-company',
            component: WechatCompany
          },
          // {path: 'sdk/qq', component: WechatQQ},
          // 任务对话
          {
            name: '任务对话',
            path: 'task',
            component: resolve => require(['../../pages/robot/task/task'], resolve)
          },
          {
            name: '编辑任务',
            path: 'task/:intentId',
            component: resolve => require(['../../pages/robot/task/taskEdit'], resolve)
          }
        ]
      },
      {
        path: 'accountInfo',
        component: resolve => require(['../../pages/accountInfo'], resolve)
      },

      {
        path: 'platform',
        component: Platform
      },
      {
        path: 'workList',
        component: workList,
        children: [{
            path: '',
            redirect: 'search'
          },
          {
            path: 'search',
            component: workListSearch
          },
          {
            path: 'new',
            component: workListNew,
            name: '创建工单'
          },
          {
            path: 'detail/:id',
            component: workListDetail,
            name: '工单详情'
          },
        ]
      },
      {
        path: 'platform/lineList',
        component: lineList,
      },
      {
        path: 'platform/platformSet',
        component: platformSet
      },
      {
        path: 'allSet',
        component: AllSet,
        children: [{
            path: '',
            redirect: 'userManager'
          },
          {
            path: 'userManager',
            component: UserManager
          },
          {
            path: 'systemButt',
            component: SystemButt
          },
          {
            path: 'userGroup',
            component: UserGroup
          },
          // {path:'workList', component: WorkList}
        ]
      },
      {
        path: 'userinfo',
        component: UserInfo
      },
      {
        path: 'companyinfo',
        component: CompanyInfo
      },
      {
        path: 'rulesErrData/:tenantId/:robotId',
        component: ruleErrData
      }
    ]
  },
  {
    path: '/union',
    component: union,
    children: [{
        path: '',
        redirect: 'visitorStatistics'
      },
      {
        path: 'tenantDetail',
        component: tenantDetail,
        name: '租户详情'
      },
      {
        path: 'tenantManager/:id',
        component: tenantDetailById,
        name: '租户详情'
      },
      {
        path: 'tenantManager',
        component: tenantManager,
        name: '租户管理'
      },
      {
        path: 'orderList',
        component: resolve => require(['../../pages/union/pages/orderList'], resolve),
        name: '订单管理'
      },
      {
        path: 'visitorStatistics',
        component: visitorStatistics,
        name: '访客统计'
      }
    ]
  },
  {
    path: "*",
    redirect: "/"
  }
]
const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  },
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js